import { ApiRequest, fetchDataFromAPITyped } from "../services/api-requests";

interface onboardingLink {
    url: string;
}

export interface verifyStripeSubscriptionResponse {
    message: string;
}

export interface updateStripeSubscriptionResponse {
    message: string;
}

export const getPayoutOnboardingLink = async () => {
    const apiQuery: ApiRequest = {
        route: "stripe/onboard",
        request: {
            method: 'GET',
            entity: 'stripe',
            body: null
        }
    }
    return await fetchDataFromAPITyped<onboardingLink>(apiQuery);
}

export const verifyStripeSubscription = async () => {
    const apiQuery: ApiRequest = {
        route: "stripe/subscription/verify",
        request: {
            method: 'GET',
            entity: 'stripe',
            body: null,
        }
    }
    return await fetchDataFromAPITyped<verifyStripeSubscriptionResponse>(apiQuery);
}

export const updateStripeSubscription = async () => {
    const apiQuery: ApiRequest = {
        route: "stripe/subscription/update",
        request: {
            method: 'GET',
            entity: 'subscription',
            body: null,
        }
    }
    return await fetchDataFromAPITyped<updateStripeSubscriptionResponse>(apiQuery);
}